module.exports = __webpack_public_path__ + "static/media/facebook_referral_icon.fb4f1a7d.svg";